// extracted by css-extract-rspack-plugin
export default {"dropdown":"fyJn4"};